interface AppConstants {
  STATUS: {
    LOADING: string;
    LOADED: string;
    FILTERING: string;
    ERROR: string;
  };
  NUMBER_PRODUCT_BY_PAGE: number;
  ORDER: FilterTypes;
  ORDER_DIRECTION: OrderDirectionTypes;
  FILTER: FilterTypes
}
interface FilterEntry {
  FIELD: string;
  NAME: string;
}

interface FilterTypes {
  [key: string]: FilterEntry;
}
interface OrderDirectionTypes {
  [key: string]: string;
}

export const APP: AppConstants = {
    STATUS: {
        LOADING: 'loading',
        LOADED: 'loaded',
        FILTERING: 'filtering',
        ERROR : 'error',
    },
    NUMBER_PRODUCT_BY_PAGE : 10,
    ORDER : {
      SCORE: {
        FIELD: 'score',
        NAME: 'pertinence'
      },
      NAME: {
        FIELD: 'ss_product_title',
        NAME: "nom",
      },
      PRICE: {
        FIELD: 'itm_variation_prices',
        NAME: 'prix'
      },
      DATE_START: {
        FIELD: 'dm_variation_dates',
        NAME: 'date'
      },
    },
    ORDER_DIRECTION: {
      ASC : 'asc',
      DESC : 'desc',
    },
    FILTER: {
        PLACES: {
          FIELD: 'sm_product_centers',
          NAME: 'lieu'
        },
        SEARCH:{
          FIELD: 'tcphoneticm_X3b_fr_title',
          NAME: 'recherche'
        },
        DOMAINS:{
            FIELD: 'sm_field_formation_domaine',
            NAME: 'domaine'
        },
        SCHEDULE: {
            FIELD: 'sm_field_formation_schedule_global',
            NAME: 'horaire'
        },
        SHORTAGE: {
            FIELD: 'bs_field_formation_shortage',
            NAME: 'penurie'
        },
        PRICERANGE:{
            FIELD: 'itm_variation_prices',
            NAME: 'prix'
        },
        PUBLIC:{
            FIELD: 'itm_field_formation_age',
            NAME: 'publique'
        },
        STARTDATE:{
            FIELD: 'dm_variation_dates',
            NAME: 'debut'
        },
        TYPE_FORMATION:{
            FIELD: 'sm_field_formation_type',
            NAME: 'objectif'
        }
    }
};
